import { render, staticRenderFns } from "./PageConfirm.vue?vue&type=template&id=b1291b3e&"
import script from "./PageConfirm.vue?vue&type=script&lang=ts&"
export * from "./PageConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports